import { defineNuxtPlugin, useHead } from '#app'

// When the inline page-zoom script (APP_ZOOM_SCRIPT, app/render/lib/pageZoom.ts) fell
// back to the design-width viewport meta, hand that value to unhead too. unhead sets
// every managed attribute back to its own value on each head render — hydration and
// every page change — so without this entry it would restore `width=device-width`
// while `--app-zoom` stays 1, leaving the page unscaled.
export default defineNuxtPlugin(() => {
  if (document.documentElement.getAttribute('data-page-scale') !== 'meta') return
  const content = document.querySelector('meta[name="viewport"]')?.getAttribute('content')
  if (content) useHead({ meta: [{ name: 'viewport', content }] })
})
